<mat-spinner *ngIf="loading" color="primary" diameter="24"></mat-spinner>
<mat-form-field *ngIf="!loading" appearance="outline">
  <mat-label>Bedrijf</mat-label>
  <mat-select
    [value]="selectedCompany"
    (selectionChange)="companySelected($event.value)"
  >
    <mat-option *ngFor="let item of companyOptions" [value]="item">
      {{ item.regularName }}
    </mat-option>
  </mat-select>
</mat-form-field>
